import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import Badge from '@uikit/components/Badge/Badge';
import { BadgeColor } from '@uikit/components/Badge/consts';
import Image from '@uikit/components/Image/Image';
import Rotate from '@uikit/components/Rotate/Rotate';
import Section from '@uikit/components/Section/Section';
import clsx from 'clsx';
import Button from '../Button/Button';
import { ButtonAlign, ButtonSize } from '../Button/consts';
import { ClickableAction } from '../Clickable/consts';
import { WIDESCREEN_BREAKPOINT_ASPECT_RATIO_CONFIGS } from '../LegacyPicture/consts';
import RegioBadge from '../RegioBadge/RegioBadge';
import { SectionVariant } from '../Section/consts';
import styles from './RegioKeyVisualSection.module.scss';
import type { RegioKeyVisualSectionProps } from './interfaces';

const RegioKeyVisualSection = ({
  id,
  image,
  title,
  badgeText,
  mainText,
  highlightedText,
  linkText,
  link,
}: RegioKeyVisualSectionProps) => {
  const isMobile = useIsMobile(768);

  return (
    <Section
      hasPadding={false}
      sectionId={id}
      variant={SectionVariant.LargePaddingBottom}
    >
      <Image
        image={image}
        breakpointAspectRatioConfigs={
          WIDESCREEN_BREAKPOINT_ASPECT_RATIO_CONFIGS
        }
        actionType={ClickableAction.None}
        scaleToFit
      />
      {badgeText && (
        <div className={styles.badgeMobile}>
          <Rotate degrees={15}>
            <RegioBadge color={BadgeColor.Green}>{badgeText}</RegioBadge>
          </Rotate>
        </div>
      )}

      <div className={styles.content}>
        {badgeText && (
          <div className={styles.badgeDesktop}>
            <Rotate degrees={15}>
              <Badge noTail color={BadgeColor.Green}>
                {badgeText}
              </Badge>
            </Rotate>
          </div>
        )}
        <h3 className={styles.title}>{title}</h3>
        <p className={clsx(styles.text, styles.mainText)}>{mainText}</p>
        <p className={clsx(styles.text, styles.highlightedText)}>
          {highlightedText}
        </p>
        <Button
          actionType={ClickableAction.Linkextern}
          align={ButtonAlign.Center}
          linkextern={link}
          className={styles.button}
          size={isMobile ? ButtonSize.Medium : ButtonSize.Large}
        >
          {linkText}
        </Button>
      </div>
    </Section>
  );
};

export default RegioKeyVisualSection;
